import { useState } from "react";
import { toast } from "sonner";
import { Phone, Check, X, Loader2 } from "lucide-react";
import { Input } from "./ui/input";
import { api } from "../lib/api";

// Inline profile row: rider views/updates his mobile number (same style as the email row).
export const PortalPhoneCard = ({ phone, onSaved }) => {
  const [edit, setEdit] = useState(false);
  const [val, setVal] = useState(phone || "");
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try { const r = await api.portalSetPhone(val); onSaved?.(r.phone); setEdit(false); toast.success("تم تحديث رقم الجوال"); }
    catch (e) { toast.error(e?.response?.data?.detail || "تعذّر الحفظ"); }
    finally { setBusy(false); }
  };
  return (
    <div className="flex items-center justify-between gap-2 py-2.5 border-b border-slate-100" data-testid="portal-phone-card">
      <span className="text-sm text-slate-500 shrink-0">رقم الجوال</span>
      {edit ? (
        <div className="flex items-center gap-1 min-w-0">
          <Input data-testid="portal-phone-input" dir="ltr" inputMode="tel" value={val} onChange={(e) => setVal(e.target.value)} placeholder="05xxxxxxxx" className="h-8 w-36 text-sm" autoFocus />
          <button onClick={save} disabled={busy} data-testid="portal-phone-save" className="rounded-md bg-emerald-600 p-1.5 text-white">{busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Check className="h-3.5 w-3.5" />}</button>
          <button onClick={() => { setEdit(false); setVal(phone || ""); }} className="rounded-md border border-slate-200 p-1.5 text-slate-500"><X className="h-3.5 w-3.5" /></button>
        </div>
      ) : (
        <div className="flex items-center gap-2 min-w-0">
          <span className="text-sm font-semibold text-slate-800 font-mono-nums" dir="ltr" data-testid="portal-phone-value">{phone || "—"}</span>
          <button onClick={() => { setVal(phone || ""); setEdit(true); }} data-testid="portal-phone-edit"
            className="shrink-0 text-emerald-600 hover:text-emerald-700 text-xs font-bold whitespace-nowrap">تغيير</button>
        </div>
      )}
    </div>
  );
};

// Mandatory: blocks the app until the rider adds his mobile number.
export const PhoneReminder = ({ phone, onSaved }) => {
  const [open, setOpen] = useState(!phone);
  const [val, setVal] = useState("");
  const [busy, setBusy] = useState(false);
  if (!open || phone) return null;
  const save = async () => {
    setBusy(true);
    try { const r = await api.portalSetPhone(val); onSaved?.(r.phone); setOpen(false); toast.success("شكراً، تم حفظ رقم الجوال"); }
    catch (e) { toast.error(e?.response?.data?.detail || "تعذّر الحفظ"); }
    finally { setBusy(false); }
  };
  return (
    <div className="fixed inset-0 z-[70] flex items-end sm:items-center justify-center bg-slate-900/40 p-3" dir="rtl" data-testid="phone-reminder">
      <div className="w-full max-w-sm rounded-3xl bg-white p-5 shadow-2xl animate-in slide-in-from-bottom-6 duration-300">
        <div className="mx-auto mb-3 flex h-14 w-14 items-center justify-center rounded-2xl bg-emerald-50 text-emerald-600"><Phone className="h-7 w-7" /></div>
        <h3 className="text-center font-heading text-lg font-extrabold">أضف رقم جوالك</h3>
        <p className="mt-1 text-center text-sm text-slate-500">إضافة رقم الجوال إلزامية لاستخدام التطبيق</p>
        <Input data-testid="phone-reminder-input" dir="ltr" inputMode="tel" value={val} onChange={(e) => setVal(e.target.value)} placeholder="05xxxxxxxx" className="mt-4 h-11 text-center text-lg" autoFocus />
        <button onClick={save} disabled={busy || !val.trim()} data-testid="phone-reminder-save" className="mt-3 flex h-11 w-full items-center justify-center gap-2 rounded-xl bg-emerald-600 font-bold text-white disabled:opacity-60">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Check className="h-4 w-4" />} حفظ</button>
      </div>
    </div>
  );
};
